export const selectDeviceType = state => state.deviceType;
